module.exports = __webpack_public_path__ + "img/way_arrow-left.7724f0db.svg";